module.exports = __webpack_public_path__ + "src/assets/img/szst_xtxt_01@2x.089c6dd7.png";